/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ caseNumber: NonNullable<unknown> }} Notifications_Task_Completed_Holder_BodyInputs */

const en_notifications_task_completed_holder_body = /** @type {(inputs: Notifications_Task_Completed_Holder_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A task was completed on case ${i?.caseNumber} where you still have open work.`)
};

const pt_br2_notifications_task_completed_holder_body = /** @type {(inputs: Notifications_Task_Completed_Holder_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uma atividade foi concluída no caso ${i?.caseNumber}, onde você ainda tem trabalho em aberto.`)
};

/**
* | output |
* | --- |
* | "A task was completed on case {caseNumber} where you still have open work." |
*
* @param {Notifications_Task_Completed_Holder_BodyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_task_completed_holder_body = /** @type {((inputs: Notifications_Task_Completed_Holder_BodyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Task_Completed_Holder_BodyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_task_completed_holder_body(inputs)
	return pt_br2_notifications_task_completed_holder_body(inputs)
});